import React from 'react';
import ProximityTableSmall from './ProximityTableSmall';
import { AiOutlineCloseSquare } from "react-icons/ai";

const Modal = (props) => {
    // if(!props.open) return null;

    return (
            <div className='relative'>
            <div className={`${props.open ?
                'md:absolute md:top-0 md:-left-96 mt-4 px-2 pb-10 h-fit bg-white bg-opacity-80 z-20'
                : 'absolute -top-8 md:top-4 -left-96 -z-10 opacity-0'} duration-500`}>

                {props.open &&
                <div className='flex'>
                    <div className='modalContent flex-inline z-10 bg-white'>
                        <ProximityTableSmall data={props.data}
                                             handleShowBtn={props.handleShowBtn}/>
                        <p className='mt-4 text-right text-sm font-semibold
                                      hover:cursor-pointer'
                           onClick={props.onClick}> More > </p>

                    </div>
                    <div className='relative'>
                    <div className='modalRight z-20 mx-2 absolute top-2 right-0'>
                        <AiOutlineCloseSquare className='text-right text-xl font-semibold
                                                         hover:cursor-pointer'
                                              onClick={props.onClose}/>
                    </div>
                    </div>
                </div>
                }

            </div>
            </div>
     );
}

export default Modal;
